class CardListController
{
  constructor()
  {
    this.name = 'card-list';
    this.props = {
      itemComponent: {
      },
      listItems: {
        default: ()=>([]),
      },
      isModal: {
        default:false,
      },
      isEval:{},
    };
    this.methods = {
      onItemClicked: this.onItemClicked,
    };
  }
  onItemClicked(ev)
  {
    this.$emit('list-item-clicked', {
      list: this,
      item: ev.target,
      itemData: ev.itemData,
    });
  }
}

export default CardListController;



// WEBPACK FOOTER //
// ./src/foundation/ui/controls/card-list/controller.js